import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { Swiper } from 'swiper/react';

export const StyledSwiper = styled(Swiper)(({ theme }) => ({
  '--swiper-theme-color': theme.palette.primary.main,
  '--swiper-pagination-color': theme.palette.secondary.main,
  '--swiper-pagination-bullet-inactive-color': theme.palette.secondary.main,
  '--swiper-pagination-bullet-inactive-opacity': 0.25,
  '--swiper-pagination-bullet-horizontal-gap': '2px',
  '--swiper-pagination-bullet-height': '0.25rem',
  '--swiper-pagination-bullet-width': '1rem',
  '--swiper-pagination-bullet-border-radius': '1rem',

  height: '100%',
  width: '100%',

  '&[data-loading="true"]': {
    '.swiper-pagination-bullets, button[data-direction]': {
      display: 'none !important',
    },
  },

  '@media (hover: hover)': {
    '&:hover button[data-direction]': {
      opacity: 1,
      pointerEvents: 'auto',
    },
  },

  '.swiper-pagination-bullets': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const ImageSlide = styled('a')(() => ({
  display: 'block',
  height: '100%',
  width: '100%',

  '> img': {
    height: '100%',
    objectFit: 'cover',
    width: '100%',
  },
}));

export const HeroImageSlide = styled(ImageSlide)(() => ({
  position: 'relative',
}));

export const LoaderContainer = styled('div')(() => ({
  background: 'rgba(255, 255, 255, 0.4)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  inset: '0',
}));

export const ViewMoreSlide = styled('a')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.primary.faint,
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  textDecoration: 'none',
  width: '100%',
}));

export const NavButton = styled(IconButton)<IconButtonProps>(({ theme }) => ({
  background: theme.palette.background.default,
  boxShadow: theme.shadows[3],
  opacity: 0,
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 1,

  '&:hover': {
    background: theme.palette.background.default,
  },

  '&:focus-visible': {
    opacity: 1,
  },

  '.MuiSvgIcon-root': {
    pointerEvents: 'none',
  },

  '&[data-direction="prev"]': {
    left: theme.spacing(1),
  },

  '&[data-direction="next"]': {
    right: theme.spacing(1),
  },

  '&:disabled': {
    opacity: '0 !important',
    pointerEvents: 'none',
  },
}));
